import React from "react";
import Button from "./Button";

const WantProductForm = ({
  form,
  onChange,
  onSubmit,
  onCancel,
  loading,
}) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-4 md:p-6 mb-6 border">

      <h2 className="text-lg md:text-xl font-semibold mb-4">
        New Wanted Listing
      </h2>

      <div className="grid grid-cols-1 gap-3">

        {/* NAME */}
        <input
          name="name"
          placeholder="What are you looking for?"
          value={form.name}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* BUDGET */}
        <input
          name="budget"
          type="number"
          placeholder="Budget"
          value={form.budget}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* LOCATION */}
        <input
          name="location"
          placeholder="Location"
          value={form.location}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* DESCRIPTION */}
        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={onChange}
          rows="4"
          className="border p-2 rounded-md w-full"
        />

        {/* PHONE */}
        <input
          name="contact_phone"
          type="tel"
          placeholder="Phone Number"
          value={form.contact_phone}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

        {/* WHATSAPP */}
        <input
          name="contact_whatsapp"
          type="tel"
          placeholder="WhatsApp Number"
          value={form.contact_whatsapp}
          onChange={onChange}
          className="border p-2 rounded-md w-full"
        />

      </div>

      {/* BUTTONS */}
      <div className="flex flex-col md:flex-row gap-3 mt-4">

        <Button
          onClick={onSubmit}
          disabled={loading}
          className="w-full md:w-auto"
        >
          {loading ? "Saving..." : "Save"}
        </Button>

        <Button
          variant="outline"
          onClick={onCancel}
          className="w-full md:w-auto"
        >
          Cancel
        </Button>

      </div>

    </div>
  );
};

export default WantProductForm;